import { AspenTasksService, TaskDTO } from '../client'
import { useTaskWorkflow } from './useTaskWorkflow'

export const useSyncPatientChangesToSnowflake = (patientId: string) => {
    return useTaskWorkflow<TaskDTO>(patientId, AspenTasksService.syncPatientChangesToSnowflakeTasksSyncPatientChangesToSnowflakePatientIdGet)
}
